<template>
  <PageSection
    v-if="listAgents.length > 0"
  >
    <PageSectionHeading>
      Offered By
    </PageSectionHeading>
    <div
      class="flex flex-col gap-7 xl:gap-14 text-center xl:text-left mx-10"
    >
      <div
        v-for="user in listAgents"
        :key="user.id"
        class="flex flex-col xl:flex-row gap-5 xl:gap-10"
      >
        <div
          class="xl:flex-shrink"
        >
          <img
            alt="Broker Profile"
            class="rounded-full w-40 mx-auto shadow xl:rounded-none user-profile"
            :src="getUserPhotoUrl(user)"
          >
        </div>
        <div
          class="xl:flex-1"
        >
          <div
            class="flex flex-col-reverse xl:flex-row gap-4 xl:gap-0"
          >
            <div
              class="flex-1"
            >
              <div
                class="text-2xl leading-tight font-book mb-5 xl:text-3xl xl:font-normal"
              >
                {{ user.getName() }}
              </div>
              <div
                class="flex flex-col gap-2 text-xs xl:text-sm"
              >
                <Link
                  v-if="user.hasPrimary('phone_number')"
                  :href="`tel:${user.getPrimary('phone_number').number}`"
                >
                  <font-awesome-icon
                    class="mr-1 xl:mr-2"
                    icon="phone-alt"
                  />
                  {{ formatPhoneNumber(user.getPrimary('phone_number')) }}
                </Link>
                <Link
                  v-if="user.email"
                  :href="`mailto:${user.email}`"
                >
                  <font-awesome-icon
                    class="mr-1 xl:mr-2"
                    icon="envelope"
                  />
                  {{ user.email }}
                </Link>
              </div>
              <UrlList
                v-if="user.urls.length > 0"
                class="mt-7 xl:mt-14 justify-center xl:justify-start"
                :items="user.urls"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </PageSection>
</template>

<script>
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons/faPhoneAlt';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { library } from '@fortawesome/fontawesome-svg-core';

import defaultUserPhotoUrl from '../assets/profile.jpeg';
import formatPhoneNumber from '../../../helpers/formatPhoneNumber';
import Link from '../components/Link.vue';
import PageSection from '../components/PageSection.vue';
import PageSectionHeading from '../components/PageSectionHeading.vue';
import UrlList from '../components/UrlList.vue';

export default {
  name: 'PropertyBrokerInfo',

  display({ isBranded, listAgents }) {
    return isBranded && listAgents.length > 0;
  },

  components: {
    Link,
    PageSection,
    PageSectionHeading,
    UrlList,
  },

  props: {
    listAgents: {
      required: true,
      type: Array,
    },
    property: {
      required: true,
      type: Object,
    },
  },

  async created() {
    library.add(faPhoneAlt);
    library.add(faEnvelope);
  },

  methods: {
    /** @return {null|string} */
    formatPhoneNumber,

    /** @return {string} */
    getUserPhotoUrl(user) {
      return user.hasPrimary('photo')
        ? user.getPrimary('photo').url
        : defaultUserPhotoUrl;
    },
  },
};
</script>

<style>
.user-profile {
  aspect-ratio: 1/1;
  object-fit: cover;
}

@screen xl {
  .user-profile {
    aspect-ratio: 147/202;
    object-fit: cover;
  }
}
</style>
